import { COLORS } from '@cuemath/comps';

export const TEACHER_RETENTION_RATE_TAB = 'retention-rate';
export const PAUSE_DETAILS_TAB = 'pause';
export const TRIAL_PROFILE = 'trial-profile';

export const TEACHER_PERFORMANCE_STATES = {
  PRIME_TUTOR: 'PRIME',
  PRO_TUTOR: 'PRO',
  PROFICIENT_TUTOR: 'PROFICIENT',
  STANDARD_TUTOR: 'STANDARD',
  PIP: 'PIP',
  TERMINATION: 'TERMINATE',
  NOT_CONSIDERED: 'NOT_CONSIDERED',
};
export const TEACHER_PERFORMANCE_STATES_CONFIG = {
  [TEACHER_PERFORMANCE_STATES.PRIME_TUTOR]: {
    color: COLORS.FLOWER_XDARK,
    bgColor: COLORS.FLOWER_XXLIGHT,
  },
  [TEACHER_PERFORMANCE_STATES.PRO_TUTOR]: {
    color: COLORS.SKY_XDARK,
    bgColor: COLORS.SKY_XXLIGHT,
  },
  [TEACHER_PERFORMANCE_STATES.PROFICIENT_TUTOR]: {
    color: COLORS.SKY_XDARK,
    bgColor: COLORS.SKY_XXLIGHT,
  },
  [TEACHER_PERFORMANCE_STATES.STANDARD_TUTOR]: {
    color: COLORS.SKY_XDARK,
    bgColor: COLORS.SKY_XXLIGHT,
  },
  [TEACHER_PERFORMANCE_STATES.PIP]: {
    color: COLORS.HEART_XDARK,
    bgColor: COLORS.HEART_XXLIGHT,
  },
  [TEACHER_PERFORMANCE_STATES.TERMINATION]: {
    color: COLORS.HEART_XDARK,
    bgColor: COLORS.HEART_XXLIGHT,
  },
  [TEACHER_PERFORMANCE_STATES.NOT_CONSIDERED]: {
    hideRetentionRate: true,
  },
};

export const RETENTION_STATUS = {
  ACTIVE: 'ACTIVE',
  NOT_RETAINED: 'NOT_RETAINED',
  INELIGIBLE: 'NOT_ELIGIBLE',
  EXCEPTION: 'EXCEPTION',
};

export const RETENTION_STATUS_CONFIG = {
  [RETENTION_STATUS.ACTIVE]: {
    label: 'Active',
  },
  [RETENTION_STATUS.NOT_RETAINED]: {
    label: 'Not retained',
  },
  [RETENTION_STATUS.INELIGIBLE]: {
    label: 'Ineligible',
  },
  [RETENTION_STATUS.EXCEPTION]: {
    label: 'Exception',
  },
};

export const RETENTION_STATUS_FILTER_OPTIONS = [
  {
    text: RETENTION_STATUS_CONFIG?.[RETENTION_STATUS?.ACTIVE]?.label,
    key: RETENTION_STATUS?.ACTIVE,
    value: RETENTION_STATUS?.ACTIVE,
  },
  {
    text: RETENTION_STATUS_CONFIG?.[RETENTION_STATUS?.NOT_RETAINED]?.label,
    key: RETENTION_STATUS?.NOT_RETAINED,
    value: RETENTION_STATUS?.NOT_RETAINED,
  },
  {
    text: RETENTION_STATUS_CONFIG?.[RETENTION_STATUS?.INELIGIBLE]?.label,
    key: RETENTION_STATUS?.INELIGIBLE,
    value: RETENTION_STATUS?.INELIGIBLE,
  },
  {
    text: RETENTION_STATUS_CONFIG?.[RETENTION_STATUS?.EXCEPTION]?.label,
    key: RETENTION_STATUS?.EXCEPTION,
    value: RETENTION_STATUS?.EXCEPTION,
  },
];

export const TEACHER_DETAILS_DRAWERS = {
  LICENSE: 'teacher-licenses',
  TRIAL_PREFERENCE: 'trial-preferences',
};

export const TEACHER_DETAILS_DRAWERS_CONFIG = {
  [TEACHER_DETAILS_DRAWERS.LICENSE]: {
    label: 'License & Tests',
  },
  [TEACHER_DETAILS_DRAWERS.TRIAL_PREFERENCE]: {
    label: 'Trial Preferences',
  },
};

export const TEACHER_TEST_TYPES = {
  MATH: 'math',
  SOP: 'sop',
};

export const CET_TEST_TYPE = {
  MATH_TEST: 'MATH_TEST',
  MATH_TEST_SOP: 'MATH_TEST_SOP',
  SOP: 'SOP',
};

export const TEACHER_TEST_STATUS = {
  IN_REVIEW: 'IN_REVIEW',
  PASS: 'PASS',
  FAIL: 'FAIL',
};

export const TEACHER_TEST_STATUS_CONFIG = {
  [TEACHER_TEST_STATUS.IN_REVIEW]: {
    label: 'In review',
  },
  [TEACHER_TEST_STATUS.PASS]: {
    label: 'Passed',
  },
  [TEACHER_TEST_STATUS.FAIL]: {
    label: 'Failed',
  },
};

export const TEACHER_TEST_TYPES_CONFIG = {
  [TEACHER_TEST_TYPES.MATH]: {
    label: 'Math',
  },
  [TEACHER_TEST_TYPES.SOP]: {
    label: 'SOP',
  },
};
